import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/website_images/logo.png";
import background_image from "../../assets/website_images/background_image.png";
import slider_arrow_icon from "../../assets/website_images/slider_arrow_icon.png";
import yellow_arrow_element from "../../assets/website_images/yellow_arrow_element.png";
import blue_arrow_element_2 from "../../assets/website_images/blue_arrow_element_2.png";
import product_image_one from "../../assets/website_images/product_image_one.png";
import product_image_two from "../../assets/website_images/product_image_two.png";
import product_image_three from "../../assets/website_images/product_image_three.png";
import product_image_four from "../../assets/website_images/product_image_four.png";
import yellow_circle_element from "../../assets/website_images/yellow_circle_element.png";
import demo_image from "../../assets/website_images/demo_image.png";
import axon from "../../assets/website_images/axon_logo.png";
import amazon from "../../assets/website_images/amazon_logo.png";
import ebay from "../../assets/website_images/ebay_logo.png";
import qantas from "../../assets/website_images/qantas_logo.png";
import alitalia from "../../assets/website_images/alitalia_logo.png";
import magento from "../../assets/website_images/magento_logo.png";
import shopify from "../../assets/website_images/shopify_logo.png";
import expedia from "../../assets/website_images/expedia_logo.png";
import wix from "../../assets/website_images/wix_logo.png";
import nykaa from "../../assets/website_images/nykaa_logo.png";
import about_image from "../../assets/website_images/about_image.png";
import blue_tick_icon from "../../assets/website_images/blue_tick_icon.png";
import newsletter_image from "../../assets/website_images/newsletter_image.png";
import careers_background from "../../assets/website_images/careers_background.png";
import map_image from "../../assets/website_images/map_image.png";
import phone_icon from "../../assets/website_images/phone_icon.png";
import email_icon from "../../assets/website_images/email_icon.png";
import location_icon from "../../assets/website_images/location_icon.png";
import facebook_icon from "../../assets/website_images/facebook_icon.png";
import twitter_icon from "../../assets/website_images/twitter_icon.png";
import instagram_icon from "../../assets/website_images/instagram_icon.png";
import essential_exhibitor_package_image from "../../assets/website_images/essential_exhibitor_package_image.png";
import organiser_pro_image from "../../assets/website_images/organiser_pro_image.png";
import enterprise_empowerment_image from "../../assets/website_images/enterprise_empowerment_image.png";
import testimonial_one from "../../assets/website_images/testimonial_one.png";
import testimonial_two from "../../assets/website_images/testimonial_two.png";
import testimonial_three from "../../assets/website_images/testimonial_three.png";
import background_image_two from "../../assets/website_images/background_image_two.png";
import background_image_three from "../../assets/website_images/background_image_three.png";
import background_image_four from "../../assets/website_images/background_image_four.png";
import "./LandingPageStyling.css";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";

const LandingPage = () => {
  const [imageCount, setImageCount] = useState(1);
  const [hamburger, setHamburger] = useState(false);

  const handleImageIncrement = () => {
    const newImageCount = imageCount + 1;
    setImageCount(newImageCount);
  };

  const handleImageDecrement = () => {
    const newImageCount = 1;
    setImageCount(newImageCount);
  };

  return (
    <div>
      {/* Navbar */}

      <nav className="fixed top-0 flex justify- items-center px-10 bg-white z-50 w-full website-navbar">
        {/* Hamburger */}
        <img
          src={hamburger_icon}
          alt="hamburger"
          onClick={() => setHamburger(!hamburger)}
          className="website--hamburger object-contain"
        />
        {hamburger && (
          <div className="absolute flex flex-col top-16 bg-white p-4 w-[80%] rounded-lg border border-black">
            <a href="#home" className="w-[10%] my-2">
              Home
            </a>
            <hr />
            <a href="#subscription" className="w-[20%] my-2">
              Subscription
            </a>
            <hr />
            <a href="#products" className="w-[20%] my-2">
              Product Features
            </a>
            <hr />
            <a href="#demo" className="w-[20%] my-2">
              Get a Demo
            </a>
            <hr />
            <a href="#about" className="w-[15%] my-2">
              About Us
            </a>
            <hr />
            <a href="#faq" className="w-[20%] my-2">
              FAQ
            </a>
          </div>
        )}

        <div className="w-[20%]">
          <img src={logo} alt="clear result" className="w-52 object-contain" />
        </div>

        <div className="flex justify-between w-[55%] website--nav-elements">
          <a href="#home" className="w-[10%]">
            Home
          </a>
          <a href="#subscription" className="w-[20%]">
            Subscription
          </a>
          <a href="#products" className="w-[25%]">
            Product Features
          </a>
          <a href="#demo" className="w-[20%]">
            Get a Demo
          </a>
          <a href="#about" className="w-[15%]">
            About Us
          </a>
          <a href="#faq" className="w-[20%]">
            FAQ
          </a>
        </div>

        <div className="w-[35%] flex justify-end ">
          <Link
            to="/dashboard"
            className="mx-3 bg-[#2F80ED] text-white text-[16px] p-2  w-[10rem] flex justify-center items-center rounded-lg website--login"
          >
            Login
          </Link>
          <button className="mx-3 border border-[#2F80ED] text-[16px] p-2 w-[10rem] flex justify-center items-center rounded-lg website--login">
            Contact Us
          </button>
        </div>
      </nav>

      {/* Home screen */}
      <div className=" my-24" id="home">
        {imageCount === 1 ? (
          <img
            src={background_image}
            alt="background"
            className=" relative w-full"
          />
        ) : null}
        {imageCount === 2 ? (
          <img
            src={background_image_two}
            alt="background"
            className="w-full "
          />
        ) : null}
        {imageCount === 3 ? (
          <img
            src={background_image_three}
            alt="background"
            className="w-full"
          />
        ) : null}
        {imageCount === 4 ? (
          <img
            src={background_image_four}
            alt="background"
            className="w-full"
          />
        ) : null}
        <div className="w-[30%] absolute top-52 left-20 bg-[#EAF3FF] p-8 rounded-lg website-welcome-card">
          <p className="text-[#F6B801] text-[16px] font-bold">
            Welcome to Clear
          </p>
          <p className="text-[#F6B801] text-[16px] font-bold">Result!</p>
          <p className="text-[#3C3C3C] text-[30px] font-bold my-3 website--font-12">
            Your Ultimate CRM Solution for Garment Industry Exhibitions
          </p>
          <img
            src={yellow_arrow_element}
            alt="yellow arrow element"
            className="absolute right-0 top-32 website-yellow-arrow"
          />
          <button className="bg-[#2F80ED] my-4 py-3 w-[70%] rounded-lg text-white text-[16px] website--font-12">
            Get Started
          </button>
        </div>
        {imageCount < 4 ? (
          <img
            src={slider_arrow_icon}
            alt="slider_arrow"
            className="absolute top-96 right-10 cursor-pointer website-slider-arrow"
            onClick={handleImageIncrement}
          />
        ) : null}
        {imageCount >= 4 ? (
          <img
            src={slider_arrow_icon}
            alt="slider_arrow"
            className="absolute top-96 right-10 cursor-pointer rotate-180 website-slider-arrow"
            onClick={handleImageDecrement}
          />
        ) : null}
      </div>

      {/* Product Features */}
      <div className="bg-[#EAF3FF] relative pb-20" id="products">
        <h1 className="text-[#333333] text-[40px] ml-20 pt-10">
          Product Features
        </h1>
        <p className="text-[16px] ml-20 mt-6">
          Get the sneak peak of the product features.
        </p>
        <img
          src={blue_arrow_element_2}
          alt="blue arrow"
          className="absolute left-80 top-16 -rotate-45 website-blue-arrow"
        />
        <div className="bg-white flex w-[70%] rounded-3xl p-8 px-12 mt-20 ml-20 relative z-10 website-product-card">
          <div className="w-[50%] website-width-90">
            <p className="text-[#111827] text-[20px] font-bold my-4">
              Your pipeline at a glance.
            </p>
            <hr />
            <p className="text-[#374151] mt-4 text-[20px]">
              Each opportunity is listed as a card with all the essential
              information; and each stage gives an overview of your expected
              revenues.
            </p>
          </div>
          <div className="w-[50%] flex justify-end website-width-90">
            <img
              src={product_image_one}
              alt="product"
              className="object-contain"
            />
          </div>
        </div>
        <div className="absolute right-32 top-[30rem] z-0">
          <img src={yellow_circle_element} alt="yellow circle" />
        </div>

        <div className="w-[100%] flex justify-end">
          <div className="bg-white flex w-[70%] rounded-3xl p-8 mt-20 mr-20 relative z-10 website-product-card">
            <div className="w-[50%] flex justify-start website-width-90">
              <img
                src={product_image_two}
                alt="product"
                className="object-contain"
              />
            </div>
            <div className="w-[50%] website-width-90">
              <p className="text-[#111827] text-[20px] font-bold my-4">
                Your pipeline at a glance.
              </p>
              <hr />
              <p className="text-[#374151] mt-4 text-[20px]">
                Each opportunity is listed as a card with all the essential
                information; and each stage gives an overview of your expected
                revenues.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white flex w-[70%] rounded-3xl p-8 px-12 mt-20 ml-20 relative z-10 website-product-card">
          <div className="w-[50%] website-width-90">
            <p className="text-[#111827] text-[20px] font-bold my-4">
              Your pipeline at a glance.
            </p>
            <hr />
            <p className="text-[#374151] mt-4 text-[20px]">
              Each opportunity is listed as a card with all the essential
              information; and each stage gives an overview of your expected
              revenues.
            </p>
          </div>
          <div className="w-[50%] flex justify-end website-width-90">
            <img
              src={product_image_three}
              alt="product"
              className="object-contain"
            />
          </div>
        </div>

        <div className="w-[100%] flex justify-end">
          <div className="bg-white flex w-[70%] rounded-3xl p-8 mt-20 mr-20 relative z-10 website-product-card">
            <div className="w-[50%] flex justify-start website-width-90">
              <img
                src={product_image_four}
                alt="product"
                className="object-contain"
              />
            </div>
            <div className="w-[50%] website-width-90">
              <p className="text-[#111827] text-[20px] font-bold my-4">
                Your pipeline at a glance.
              </p>
              <hr />
              <p className="text-[#374151] mt-4 text-[20px]">
                Each opportunity is listed as a card with all the essential
                information; and each stage gives an overview of your expected
                revenues.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Plans */}
      <div className="relative my-20 " id="subscription">
        <hr />
        <div className="text-center text-[#333333] text-[32px] mt-8 font-bold">
          Subscription Plans
        </div>
        <div className="text-center text-[#333333] text-[18px] mt-6">
          We help you choose a plan that is right for you. Save more with better
          plans.
        </div>
        <img
          src={blue_arrow_element_2}
          alt="blue arrow"
          className="absolute right-96 top-16 website-blue-arrow"
        />
        <div className="w-full flex justify-center items-center mt-10 ">
          <div className="z-10 relative flex website-subscription-card">
            <img
              src={essential_exhibitor_package_image}
              alt="Essential Exhibitor Package"
              className="object-contain cursor-pointer"
            />
            <img
              src={organiser_pro_image}
              alt="Essential Exhibitor Package"
              className="object-contain cursor-pointer"
            />
            <img
              src={enterprise_empowerment_image}
              alt="Essential Exhibitor Package"
              className="object-contain cursor-pointer"
            />
          </div>
        </div>

        <div className="absolute left-32 top-[30rem] z-0 website--yellow-circle">
          <img src={yellow_circle_element} alt="yellow circle" />
        </div>
      </div>

      {/* Demo */}
      <div className="relative bg-[#F2F5FF] mb-20 website-demo" id="demo">
        <div className="py-20 justify-around flex relative z-10 website-demo">
          <div>
            <img
              src={demo_image}
              alt="demo"
              className="object-contain website-demo-image"
            />
          </div>
          <div className="website-width-90">
            <p className="font-bold text-[36px] text-[#333333]">Get a Demo</p>
            <p className="text-[18px] my-5">
              Get to about our product book a demo with us!{" "}
            </p>
            <p className="text-[14px]">Email Id</p>
            <input
              type="email"
              placeholder="Business email"
              className="my-2 p-2 border-2 w-full bg-[#F2F5FF]"
            />
            <p className="text-[14px]">
              Company name <span className="text-red-600">*</span>
            </p>
            <input
              type="email"
              placeholder="Ex: Shopper Stop"
              className="my-2 p-2 border-2 w-full bg-[#F2F5FF]"
            />
            <p className="text-[14px]">
              Contact Person <span className="text-red-600">*</span>
            </p>
            <input
              type="email"
              placeholder="Ex: Shopper Stop"
              className="my-2 p-2 border-2 w-full bg-[#F2F5FF]"
            />
            <p className="text-[14px]">
              MOBILE NUMBER <span className="text-red-600">*</span>
            </p>
            <input
              type="email"
              placeholder="Ex: +91-8532418090"
              className="my-2 p-2 border-2 w-full bg-[#F2F5FF]"
            />

            <button className="text-[14px] p-2 px-8 text-[#2F80ED] bg-white border border-[#2F80ED] rounded-lg font-bold">
              Request a Demo
            </button>
          </div>
        </div>
        <div className="absolute top-52 left-20 z-0 website--yellow-circle">
          <img
            src={yellow_circle_element}
            alt="yellow circle"
            className="object-contain "
          />
        </div>
      </div>

      {/* Customer Review */}
      <div>
        <div className="text-center text-[#333333] text-[32px] mt-8 font-bold">
          Customer Review
        </div>
        <div className="text-center text-[#333333] text-[18px] mt-6">
          We take customer feedback seriously. Here's a look at what our
        </div>
        <div className="text-center text-[#333333] text-[18px]">
          users love (and not so love) about Clear Result.
        </div>

        <div className="flex justify-center items-center mt-10">
          <div className="flex website--testimonial">
            <img
              src={testimonial_one}
              alt="testimonial"
              className="object-contain"
            />
            <img
              src={testimonial_two}
              alt="testimonial"
              className="object-contain"
            />
            <img
              src={testimonial_three}
              alt="testimonial"
              className="object-contain"
            />
          </div>
        </div>

        {/* testimonial */}
        <div className="text-center text-[#333333] text-[32px] font-bold">
          Trusted Clients
        </div>
        <div className="text-center text-[#333333] text-[18px] mt-6">
          Trusted by leading clients worldwide for our unwavering commitment to
          excellence and reliability.
        </div>

        <div className="mt-10 flex items-center justify-center flex-col website-row">
          <div className="flex justify-between w-[50%] website--testimonial-companies">
            <img
              src={axon}
              alt="axon"
              className="object-contain website-client"
            />
            <img
              src={amazon}
              alt="amazon"
              className="object-contain website-client"
            />
            <img
              src={ebay}
              alt="ebay"
              className="object-contain website-client"
            />
            <img
              src={qantas}
              alt="qantas"
              className="object-contain website-client"
            />
            <img
              src={alitalia}
              alt="alitalia"
              className="object-contain website-client"
            />
          </div>
          <div className="flex justify-between w-[50%] website--testimonial-companies">
            <img
              src={magento}
              alt="magento"
              className="object-contain website-client"
            />
            <img
              src={shopify}
              alt="shopify"
              className="object-contain website-client"
            />
            <img
              src={expedia}
              alt="expedia"
              className="object-contain website-client"
            />
            <img
              src={wix}
              alt="wix"
              className="object-contain website-client"
            />
            <img
              src={nykaa}
              alt="nykaa"
              className="object-contain website-client"
            />
          </div>
        </div>

        {/* FAQ */}
        <div
          className="text-center text-[#333333] text-[32px] mt-16 font-bold"
          id="faq"
        >
          Frequently asked questions
        </div>

        <div className="w-[100%] mt-8 flex flex-col justify-center items-center">
          <hr className="w-[60%] mb-4 website-width-90" />
          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>What is Clear Result?</p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />

          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>How does it actually work?</p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />

          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>
              {" "}
              Is social media integration available in all subscription plans?
            </p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />

          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>How can I reach customer support?</p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />

          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>Does Clear Result offer a trial period?</p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />

          <div className="flex justify-between w-[60%] mb-4 website-width-90">
            <p>How does Clear Result benefit exhibitors?</p>
            <p className="rotate-90 cursor-pointer">{">"}</p>
          </div>
          <hr className="w-[60%] mb-4 website-width-90" />
        </div>
      </div>

      {/* About Us */}
      <div className="bg-[#EAF3FF] my-16 pb-10" id="about">
        <div className="text-center text-[#333333] text-[32px] pt-10 font-bold">
          About Us: Transforming Exhibitions into Success Stories
        </div>
        <div className="text-center flex-col text-[#333333] text-[18px] mt-6 mx-2">
          <p>
            We are specialise in revolutionising the post-exhibition experience,
            turning leads into lasting customer relationships. At Clear Result,
          </p>
          <p>
            we understand that the true value of an exhibition lies in what
            happens afterward - the seamless transition from leads to customers.
          </p>
          <p>
            We are here to redefine that journey, making it more intuitive,
            engaging, and ultimately, more successful.
          </p>
        </div>

        <div className="flex justify-center mt-16 relative mx-16 website-about">
          <div className="flex flex-col w-[35%] mr-10 website-width-90">
            <div className="flex flex-col bg-[#F2F7FF] mb-10 p-6 rounded-xl ">
              <div className="flex mb-6">
                <img
                  src={blue_tick_icon}
                  alt="blue tick"
                  className="object-contain"
                />
                <p className="text-[#151411] text-[24px] font-bold ml-4">
                  Our Mission
                </p>
              </div>
              <p className="text-[14px]">
                At the core of our mission is a dedication to reshaping the
                post-exhibition landscape. We aim to empower businesses with the
                tools and strategies needed to convert leads into valued
                customers, ensuring that the impact of every exhibition extends
                far beyond the event itself.
              </p>
            </div>
            <div className="flex flex-col bg-[#F2F7FF] mb-10 p-6 rounded-xl ">
              <div className="flex mb-6">
                <img
                  src={blue_tick_icon}
                  alt="blue tick"
                  className="object-contain"
                />
                <p className="text-[#151411] text-[24px] font-bold ml-4">
                  Who we are
                </p>
              </div>
              <p className="text-[14px]">
                Clear Result is not just a technology solution; we are a team of
                dedicated professionals with a passion for driving success. We
                combine industry expertise with technological innovation to
                create a post-exhibition experience that truly adds value to
                your business.
              </p>
            </div>
          </div>
          <div className="z-20 ml-10">
            <img src={about_image} alt="about" />
          </div>
          <div className="absolute top-40 right-32 z-0 website--yellow-circle">
            <img src={yellow_circle_element} alt="yellow circle" />
          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="flex justify-start ml-20 pt-8 mb-32 website--testimonial website-margin-1">
        <div className="mr-20 website-margin-1">
          <img src={newsletter_image} alt="newsletter" />
        </div>
        <div className="ml-20 website-margin-1">
          <p className="text-[30px] font-bold my-10">
            Subscribe to our Newsletter{" "}
          </p>
          <p className="text-[20px] mb-10">
            Get notified about our upcoming event and news
          </p>
          <p className="text-[20px] text-[#908F8F] mb-10">
            Be the first to get exclusive offers ands the latest news
          </p>
          <p className="text-[14px]">Email Id</p>
          <input
            type="email"
            placeholder="Business email"
            className="my-2 p-2 border-2 w-full"
          />
          <button className="text-[16px] p-3 rounded-lg text-white mt-10 w-[20rem] bg-[#2F80ED] website-width-90">
            Subscribe Now
          </button>
        </div>
      </div>

      {/* Careers */}
      <div className="relative mb-20 h-[140vh]">
        <img
          src={careers_background}
          alt="careers"
          className="relative w-full z-0 careers-background"
        />
        <div className="w-full absolute top-0 left-1/2 transform -translate-x-1/2 z-10 text-white careers-color">
          <div className="text-center text-[16px] pt-16 mb-2">Careers</div>
          <hr className="text-white w-24 absolute left-1/2 transform -translate-x-1/2" />
          <div className="text-center text-[32px] pt-10 mt-6 font-bold">
            Join us
          </div>
          <div className="flex items-center flex-col text-[18px] mt-10 ">
            <p className="text-center w-[60%]">
              In publishing and graphic design, Lorem ipsum is a placeholder
              text commonly used to demonstrate the visual form of a document or
              a typeface without relying on meaningful content. Lorem ipsum may
              be used as a placeholder before final copy is available
            </p>
          </div>

          <div className="flex flex-col">
            <div className="mt-16 flex justify-around mx-20 website-careers website-margin-1 website-join-form">
              <div>
                <p className="text-[14px] mb-2">FULL NAME</p>
                <input
                  type="text"
                  placeholder="Enter full name "
                  className="p-2 bg-transparent border border-[#FFFFFF] w-[25rem] about--form-width"
                />
              </div>
              <div>
                <p className="text-[14px] mb-2">EMAIL ID</p>
                <input
                  type="text"
                  placeholder="Enter email ID"
                  className="p-2 bg-transparent border border-[#FFFFFF] w-[25rem] about--form-width"
                />
              </div>
              <div>
                <p className="text-[14px] mb-2">MOBILE NUMBER</p>
                <input
                  type="text"
                  placeholder="Enter mobile number "
                  className="p-2 bg-transparent border border-[#FFFFFF] w-[25rem] about--form-width"
                />
              </div>
            </div>
            <div className="mt-10 flex justify-center mx-20 website-careers website-margin-1 website-join-form">
              <div className="mr-10 website-margin-1">
                <p className="text-[14px] mb-2">UPLOAD CV</p>
                <input
                  type="text"
                  placeholder="Drop your CV here"
                  className="p-2 bg-transparent border border-[#FFFFFF] w-[25rem] about--form-width"
                />
              </div>
              <div className="ml-10 website-margin-1">
                <p className="text-[14px] mb-2">MESSAGE</p>
                <input
                  type="text"
                  placeholder="Write a message for the recruiter"
                  className="p-2 bg-transparent border border-[#FFFFFF] w-[25rem] about--form-width"
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center mt-16 website-width-90">
            <button className="w-[20rem] bg-[#2F80ED] py-3 rounded-lg text-[18px] text-white">
              Proceed
            </button>
          </div>
        </div>
      </div>

      {/* Get in Touch */}
      <div className="bg-[#EAF3FF] pb-10" id="contact">
        <div className="text-center text-[#333333] text-[32px] pt-10 font-bold">
          Get in Touch
        </div>
        <div className="text-center flex-col text-[#333333] text-[18px] mt-6">
          Reach out and let's create something amazing together!
        </div>
        <div className="flex justify-around mt-10 relative items-center website-careers">
          <div>
            <div className="flex">
              <img
                src={phone_icon}
                alt="phone"
                className="object-contain mr-4"
              />
              <div>
                <p className="text-[24px] font-bold">PHONE</p>
                <p className="text-[24px]">+91-2345678997</p>
              </div>
            </div>
            <div className="flex my-8">
              <img
                src={email_icon}
                alt="email"
                className="object-contain mr-4"
              />
              <div>
                <p className="text-[24px] font-bold">EMAIL</p>
                <p className="text-[24px]">info@clearresult.co</p>
              </div>
            </div>
            <div className="flex">
              <img
                src={location_icon}
                alt="location"
                className="object-contain mr-4"
              />
              <div>
                <p className="text-[24px] font-bold">LOCATION</p>
                <p className="text-[24px]">123, ABC Street, XYZ Area,</p>
                <p className="text-[24px]">
                  Mumbai, Maharashtra, India, 400001.
                </p>
              </div>
            </div>
          </div>
          <div className="z-10">
            <img
              src={map_image}
              alt="map"
              className="ml-20 website-margin-1 website-width-90"
            />
          </div>
          <div className="absolute top-40 right-20 z-0 website--yellow-circle">
            <img src={yellow_circle_element} alt="yellow circle" />
          </div>
        </div>
      </div>

      {/* Footer  */}
      <div className="mt-20 bg-[#F5F5F5] flex justify-around pb-20 pt-10 website-footer">
        <div>
          <img src={logo} alt="logo" className="w-40 object-contain" />
          <p className="text-[16px] text-[#1E2833] ml-6">
            Copyright © 2023 Clear Result • All rights reserved
          </p>
          <div className="flex justify-between mt-10 w-[40%] ml-6">
            <img
              src={facebook_icon}
              alt="facebook"
              className="cursor-pointer"
            />
            <img src={twitter_icon} alt="twitter" className="cursor-pointer" />
            <img
              src={instagram_icon}
              alt="instagram"
              className="cursor-pointer"
            />
          </div>
        </div>
        <div className=" flex flex-col mt-10 website-footer-margin">
          <p className="text-[17px] text-[#376E9F] cursor-pointer">
            CLEAR RESULT
          </p>
          <p className="text-[15px] mt-4 cursor-pointer">
            Terms and Conditions
          </p>
          <p className="text-[15px] mt-4 cursor-pointer">Privacy Policy</p>
          <p className="text-[15px] mt-4 cursor-pointer">Careers</p>
        </div>
        <div className="flex flex-col mt-10 website-footer-margin">
          <a href="#home" className="text-[15px] mt-4 cursor-pointer">
            Home
          </a>
          <a href="#about" className="text-[15px] mt-4 cursor-pointer">
            About
          </a>
          <a href="#subscription" className="text-[15px] mt-4 cursor-pointer">
            Subscription
          </a>
          <a href="#contact" className="text-[15px] mt-4 cursor-pointer">
            Contact
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
